import styled, { css, keyframes } from 'styled-components'
import clearBtn from 'src/assets/images/rop03/icon_clear.svg'

const blink = keyframes`
    0% {
        opacity: 1;
    }
    50% {
        opacity: 0.2;
    }
    100% {
        opacity: 1;
    }
`

export const Rop03FormStyle = {
  Rop03FormBackground: styled.div`
    width: 100%;
    background-color: #f0f1f4;
  `,
  Rop03FormContainer: styled.div`
    display: flex;
    flex-direction: column;
    max-width: 492px;
    min-width: 300px;
    width: 100%;
    margin: 0 auto;

    & * {
      font-family: 'Pretendard', sans-serif;
    }
  `,
  CertFormContainer: styled.form<{ $mainBg: string }>`
    display: flex;
    flex-direction: column;
    padding: 30px 16px 0;
    background-color: ${(props) => props.$mainBg || 'white'};
    gap: 30px;
  `,

  PNumberInputStyle: ({
    backgroundColor,
    borderColor,
    isFocus,
    isValid,
  }: {
    backgroundColor?: string
    borderColor?: string
    isFocus?: boolean
    isValid?: boolean
  }) => css`
    gap: 16px;
    background-color: ${isFocus ? backgroundColor || '#faffbd' : 'white'};
    ${!isValid
      ? css`
          border: 1.5px solid #ff0000;
        `
      : css`
          border: 1.5px solid ${borderColor || '#1A6EFF'};
        `};

    & input {
      color: #1a6eff;
    }
  `,

  ClearBtn: styled.button`
    position: absolute;
    top: 50%;
    right: 12px;
    transform: translateY(-50%);
    width: 22px;
    height: 22px;
    cursor: pointer;
    background-image: url(${clearBtn});
    background-size: contain;
    background-repeat: no-repeat;
    background-color: transparent;
  `,

  OtpRequestButton: ({
    backgroundColor,
    borderRadius,
    fontColor,
    fontSize,
    fontWeight,
    letterSpacing,
  }: {
    backgroundColor: string
    borderRadius: string
    fontColor: string
    fontSize: string
    fontWeight: number
    letterSpacing: string
  }) => css`
    margin-top: 10px;
    width: 100%;
    height: 50px;
    background-color: ${backgroundColor || '#1A6EFF'};
    border: none;
    border-radius: ${borderRadius || '12px'};
    color: ${fontColor || 'var(--white)'};
    font-size: ${fontSize || '14px'};
    font-weight: ${fontWeight || 700};
    letter-spacing: ${letterSpacing || '0'};
    &:disabled {
      border: none;
      background-color: #e4e6eb;
      color: var(--white);
    }
  `,

  ApprovalNumberInputStyle: ({
    backgroundColor,
    borderColor,
    isFocus,
    isValid,
  }: {
    backgroundColor?: string
    borderColor?: string
    isFocus?: boolean
    isValid?: boolean
  }) => css`
    margin-bottom: 10px;
    gap: 10px;
    background-color: ${isFocus ? backgroundColor || '#faffbd' : 'white'};
    ${!isValid
      ? css`
          border: 1.5px solid #ff0000;
        `
      : css`
          border: 1.5px solid ${borderColor || '#1A6EFF'};
        `};

    & input:-webkit-autofill {
      -webkit-box-shadow: 0 0 0 1000px ${isFocus ? backgroundColor || '#faffbd' : 'white'} inset !important;
    }
  `,

  Timer: styled.span`
    position: absolute;
    top: 51%;
    right: 73px;
    transform: translate(0, -50%);
    color: #717580;
    font-size: 14px;
    font-weight: 500;
    line-height: 24px;

    &.danger {
      color: #ff0000;
      animation: ${blink} 0.8s ease-in-out infinite;
    }
  `,
  RetryRequestButton: ({
    backgroundColor,
    fontColor,
  }: {
    backgroundColor: string
    fontColor: string
  }) => css`
    position: absolute;
    right: 6px;
    display: flex;
    align-items: center;
    padding: 0 10px;
    width: fit-content;
    height: 38px;
    border-radius: 8px;
    border: none;
    background-color: ${backgroundColor || '#1A6EFF'};
    color: ${fontColor || 'var(--white)'};
    font-size: 14px;
    font-weight: 500;
    &:disabled {
      border: none;
      background-color: #e4e6eb;
      color: var(--white);
    }
    &:active {
      border: none;
      background-color: ${backgroundColor || '#1A6EFF'};
    }
  `,

  ResendTooltip: styled.div`
    width: 126px;
    position: absolute;
    bottom: calc(100% + 3px);
    right: 0;
    padding: 10px;
    border-radius: 12px;
    background: #313338;
    color: #fff;
    font-size: 12px;
    font-weight: 500;
    line-height: 16px;
    white-space: nowrap;
    pointer-events: none;
    text-align: center;
    & > span {
      color: inherit;
      font-weight: 700;
      text-decoration: underline;
    }
    &::after {
      content: '';
      position: absolute;
      top: 100%;
      right: 12px;
      border: 6px solid transparent;
      border-top-color: #313338;
    }
  `,

  JoinSubmitContainer: styled.div<{ $isBtnChange: boolean }>`
    margin-bottom: 30px;
    & .column {
      padding-top: 30px;
    }

    & > .btn_signup {
      ${({ $isBtnChange }) =>
        !$isBtnChange
          ? `
                padding: 0;
            `
          : `
                padding-top: 24px;
                span {
                    top: 1px;
                    right: unset;
                    transform: unset;
                    width: 30px;
                    height: 30px;
                }
            `}
    }
  `,

  JoinButton: ({
    backgroundColor,
    borderRadius,
    fontColor,
    fontSize,
    fontWeight,
    letterSpacing,
  }: {
    backgroundColor: string
    borderRadius: string
    fontColor: string
    fontSize: string
    fontWeight: number
    letterSpacing: string
  }) => css`
    background-color: ${backgroundColor || '#1A6EFF'};
    border-radius: ${borderRadius || '12px'};
    color: ${fontColor || 'var(--white)'};
    font-size: ${fontSize || '14px'};
    font-weight: ${fontWeight || 500};
    letter-spacing: ${letterSpacing || '-1.12px'};
  `,

  SwitchComp: styled.div`
    display: flex;
    flex-direction: column;
  `,

  PaidNoticeConatiner: styled.div<{ $color: string; $fontSize: string }>`
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding: 16px;
    border-top: 1px solid #e7e8ed;
    background-color: var(--white);

    & > p {
      padding-left: 8px;
      color: #484b52;
      /* font-size: ${({ $fontSize }) => $fontSize || '12px'}; */
      font-size: 14px;
      font-weight: 700;
      line-height: 1.4;
      letter-spacing: -0.02rem;

      &:nth-child(2) {
        /* color: ${({ $color }) => $color || '#ff0000'}; */
        color: #f3223c;
        font-weight: 700;
      }

      &::before {
        content: '·';
        margin-right: 6px;
        margin-left: -8px;
      }
    }
  `,

  FooterContainer: styled.div<{ $bgColor: string }>`
    padding: 16px 16px 100px;
    background-color: ${({ $bgColor }) => $bgColor || '#FAFAFA'};

    & > div > ul > li {
      color: #717580;
      line-height: 16px;
      margin-bottom: 4px;
      padding-left: 8px;

      & > strong {
        color: #717580;
        font-weight: 700;
      }

      &::before {
        content: '·';
        margin-right: 6px;
        margin-left: -8px;
      }
    }
  `,
}
